<template>
  <GmapMap
    :center="{ lat: initialPosition.lat, lng: initialPosition.lng }"
    :zoom="15"
    :options="mapConfig"
    map-type-id="roadmap"
    ref="map"
    style="width: 100%; height: 100vh"
  >
    <gmap-marker v-for="mapData of markers" :key="mapData.customer" :position="mapData.geometry"> </gmap-marker>
  </GmapMap>
</template>

<script>
import GoogleMapLoader from './GoogleMapLoader';
import DirectionsRenderer from './DirectionsRenderer';
import { gmapApi } from "vue2-google-maps";

import { mapSettings } from '../constants/mapSettings';

export default {
  components: {
    GoogleMapLoader,
    DirectionsRenderer,
  },
  props: ['markers'],
  computed: {
    google: gmapApi,
    mapConfig() {
      return {
        ...mapSettings
      };
    },
  },
  watch: {
    markers() {
      console.log('watch markers', this.markers);
      this.generate();
    }
  },
  directionsService: null,
  directionsDisplay: null,
  data() {
    return {
      initialPosition: { lat: -16.469147, lng: -54.634887 },
      waypoints: [],
      showMap: true,
      lines: [
        {
          id: '1',
          path: [],
        },
      ],
    };
  },
  mounted() {
    this.generate();
  },
  methods: {
    generate() {
      const vm = this;
      this.$nextTick(function() {
        this.$gmapApiPromiseLazy().then(() => {
          console.log(this.markers)
          this.$options.directionsService = new google.maps.DirectionsService()
          this.$options.directionsDisplay = new google.maps.DirectionsRenderer()
          this.$options.directionsDisplay.setMap(this.$refs.map.$mapObject);
          this.$options.directionsDisplay.set('directions', null)
          this.$options.directionsService.route(
            {
              origin: this.markers[0].address.geometry,
              destination: this.markers[this.markers.length - 1].address.geometry,
              travelMode: 'DRIVING',
              waypoints: this.markers.map(x => {
                return {
                  location: {
                    lat: x.address.geometry.lat,
                    lng: x.address.geometry.lng,
                  },
                  stopover: true,
                }
              }),
            },
            (result, status) => {
              console.log('result', result, status)
              if (status === 'OK') {
                this.$options.directionsDisplay.setDirections(result)
              }
            }
          )        
        })
      });

    }
  },
};
</script>
